import type { DoctorCardProps, ProviderListProps } from '@/types'
import { cn } from '@/utils/cn'


export const ProviderList: React.FC<ProviderListProps> = ({ data }) => {
  return (
    <>{data.map(doc => <DoctorCard key={doc.id} data={doc} />)}</>
  )
}

/**
 * TODO: this is actually doctor card LIST since tool call returns multiple results
 * DoctorCard displays doctor information with action buttons.
 * Fully accessible with proper ARIA labels and keyboard navigation.
 */
export function DoctorCard({ data }: DoctorCardProps) {
  const { id, firstName, lastName, city, stateAbbr, distanceMiles } = data
  const location = city && stateAbbr ? `${city}, ${stateAbbr}` : city

  return (
    <article
      className={cn(
        'rounded-lg border border-gray-200 bg-white p-4 shadow-sm',
        'transition-shadow hover:shadow-md'
      )}
      aria-labelledby={`doctor-name-${id}`}
    >
      <div className="flex gap-4">
        {/* Avatar placeholder */}
        <div
          className={cn(
            'flex h-16 w-16 shrink-0 items-center justify-center',
            'rounded-full bg-primary-100 text-primary-700'
          )}
          aria-hidden="true"
        >
          <span className="text-xl font-semibold">
            {firstName?.slice(0, 1).toUpperCase()}{lastName?.slice(0, 1).toUpperCase()}
          </span>
        </div>

        <div className="min-w-0 flex-1">
          <h3
            id={`doctor-name-${id}`}
            className="font-semibold text-gray-900"
          >
            {firstName} {lastName}
          </h3>
         

          {/* Location */}
          {location && (
            <p className="mt-2 text-sm text-gray-600">
              <span className="sr-only">Location: </span>
              {location} ({distanceMiles?.toFixed(1)} miles)
            </p>
          )}

        </div>
      </div>
    </article>
  )
}
